export var MaskBlockLayout;
(function (MaskBlockLayout) {
    MaskBlockLayout["None"] = "none";
    MaskBlockLayout["RightTop"] = "right-top";
})(MaskBlockLayout || (MaskBlockLayout = {}));
//# sourceMappingURL=mask-block-layout.js.map